const SET_OVERALL_ANSWER = 'SET_OVERALL_ANSWER';

/**
 * The action called when a rating is selected or a comment 
 * is added on the NPS overall question section.
 */
export const setOverallAnswer = (data) => {
    return {
        type: SET_OVERALL_ANSWER,
        data
    };
};




// WEBPACK FOOTER //
// ./application/containers/NPS/actions.js